import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { queryClient } from './lib/queryClient';
import { getBaseUrl } from './utils/routing';
import { ThemeProvider } from './themes';
import 'virtual:kgp-theme.css';
import './styles/index.css';

// Import StateExporter for development mode
if (import.meta.env.DEV) {
  // @ts-ignore - stateExporter is a JS file without type declarations
  import('./utils/stateExporter').then(() => {
    console.log('StateExporter loaded for development');
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={getBaseUrl()}>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
); 